<template>
    <div class="text-center">
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="400"
            bottom left
            origin="top right"
            transition="scale-transition"
            offset-y>

            <template v-slot:activator="{ on }">
                <v-btn raised elevation="1" min-width="0" text v-on="on" @dblclick="on_Validate_Form">
                    <v-icon> mdi-calendar-search</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="grey headline" style="color: white; font-size: 15px; font-weight: 500;">
                    <p class="pl-7 mb-5 mt-5">
                        Search: - 'Calendar'
                    </p>
                </v-card-title>

                <v-form ref="form" v-model="valid" lazy-validation style="background-color: #fff;">
                    <!-- >>> Fields ---------------------------------------- -->
                    <v-divider></v-divider>
                    <v-list style="background-color: #fff;">
                        <!-- Field::bases ---------------------------------- -->
                        <v-list-item>
                            <v-select
                                v-model="base"
                                :items="bases"
                                prepend-icon="mdi-home"
                                label="Select one/more Base(s):"
                                clearable
                                multiple
                                chips>
                            </v-select>
                        </v-list-item>

                        <!-- Field::positions ------------------------------ -->
                        <v-list-item>
                            <v-select
                                v-model="position"
                                :items="positions"
                                prepend-icon="mdi-account-multiple-plus"
                                label="Select one/more Position(s):"
                                clearable
                                multiple
                                chips
                                class="mt-2">
                            </v-select>
                        </v-list-item>

                        <!-- Field::funczioni ------------------------------ -->
                        <v-list-item>
                            <v-select
                                v-model="funzione"
                                :items="funzioni"
                                prepend-icon="mdi-account-details"
                                label="Select one/more Function:"
                                clearable
                                multiple
                                chips
                                class="mt-2">
                            </v-select>
                        </v-list-item>

                        <!-- Field::duties --------------------------------- -->
                        <v-list-item>
                            <v-select
                                v-model="duty"
                                :items="duties"
                                prepend-icon="mdi-apps"
                                label="Select one/more Dutie(s):"
                                clearable
                                multiple
                                chips
                                class="mt-2">
                            </v-select>
                        </v-list-item>

                        <!-- Field::stati ---------------------------------- -->
                        <v-list-item>
                            <v-select
                                v-model="status"
                                :items="stati"
                                prepend-icon="mdi-apps"
                                label="Select Status:"
                                clearable
                                chips
                                class="mt-2">
                            </v-select>
                        </v-list-item>

                        <!-- Field::crewcodes ------------------------------ -->
                        <v-list-item>
                            <v-text-field
                                v-model="crewcodes"
                                label="Put in 3 Letter Code(s):"
                                hint="Separate several with comma"
                                prepend-icon="mdi-code-tags"
                                color="secondary"
                                clearable
                                class="mt-2">
                            </v-text-field>
                        </v-list-item>

                        <!-- Field::flightnos ------------------------------ -->
                        <v-list-item>
                            <v-text-field
                                v-model="flightnos"
                                label="Put in Flight number(s):"
                                hint="Separate several with comma"
                                prepend-icon="mdi-airplane"
                                color="secondary"
                                clearable
                                class="mt-2">
                            </v-text-field>
                        </v-list-item>

                        <!-- Field::daterange ------------------------------ -->
                        <v-list-item>
                            <v-menu
                                ref="dates_dateMenuFlight"
                                v-model="datemenu_dateRange"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-combobox
                                        v-model="formattedDateRangeFlightSchedule"
                                        multiple
                                        class="sdr-custom-dates-combobox"
                                        chips
                                        v-bind="attrs"
                                        v-on="on"
                                        prepend-icon="mdi-calendar"
                                        :rules ="[
                                            rules.req(inputDateRange),
                                        ]"
                                        readonly>
                                        <template v-slot:label>
                                            Date Range <span style="color: red; font-size: 1.4rem;">*</span>
                                        </template>
                                    </v-combobox>
                                </template>
                                <v-date-picker
                                    v-model="inputDateRange"
                                    :first-day-of-week="1"
                                    no-title
                                    range>
                                    <!-- <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="datemenu_dateRange = false">
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="onClick_datemenuFlightSchedule_OK">
                                        OK
                                    </v-btn> -->
                                </v-date-picker>
                            </v-menu>
                        </v-list-item>
                    </v-list>

                    <!-- >>> Buttons --------------------------------------- -->
                    <v-card-actions class="mt-4" style="background-color: #fff;">
                        <v-spacer></v-spacer>
                        <v-btn style="width:120px; font-size:12px;" class="mb-4" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
                        <v-btn style="width:120px; font-size:12px;" class="mb-4" depressed elevation="1" color="primary" @click="on_Validate_Form"> Search</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {
        CONF_CALENDAR_DAYS_RANGE,
        CONF_SCHEDULER_TIME_RANGE_DAYS
    } from '../../../../config.js'
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';

    import dayjs from 'dayjs';
    import moment from 'moment';
    import { eventBus } from '../../../../main';


    export default {
        name: 'FilterMenue',

        /* >>> *************************************************************** / /* Data */
        data: () => ({
            // >>> ------------------------------ Date Range Menu
            datemenu_dateRange: null,
            inputDateRange: [dayjs().format('YYYY-MM-DD'), dayjs().add(CONF_SCHEDULER_TIME_RANGE_DAYS, 'days').format('YYYY-MM-DD')],
            // >>> ------------------------------
            fav: true,
            menu: false,
            message: false,
            hints: true,
            // >>> ------------------------------
            valid: false,
            position: null,
            positions: [
                'CP',
                'FO',
                'SCCM',
                'CA',
            ],
            base: null,
            bases: [
                'ZAG',
                'BRE',
                'BER',
                'DRS',
                'DUS',
                'FRA',
                'FKB',
                'KSF',
                'LEJ',
                'PAD',
            ],
            funzione: null,
            funzioni: [
				'TRE-LR',
				'TRE-L',
				'TRE-LR',
				'TRI-L',
                'TRI-LR',
				'LCC-LR',
				'LCC-L',
                'LTC-LR',
                'LTC-L',
                'CPT-LR',
                'CPT-L',
                'CPTt-L',
                'FO-R',
                'FOt-R',
                'CCS',
                'CFS',
                'X3',
            ],
            duty: null,
            duties: [
                'AVAILABLE',
                'DAYOFF',
                'FREEDAY',
                'HOTEL',
                'MEETING',
                'OFFICE',
                'PROCEEDING',
                'RES',
                'SICKNESS',
                'STANDBY',
                'TRAINING',
                'UNABLEFLIGHT',
                'VACATION',
            ],
            status: null,
            stati: [
                'PENDING',
                'BOOKED',
            ],
            crewcodes: null,
            flightnos: null,
            // >>> ------------------------------
            fromdate: new Date().toISOString().substr(0, 10),
            fromdatemenu: false,
            todate: new Date(new Date().getTime()+(+CONF_CALENDAR_DAYS_RANGE*24*60*60*1000)).toISOString().substr(0, 10), // new Date().toISOString().substr(0, 10),
            todatemenu: false,
            // >>> ------------------------------
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 3 || 'Min 3 characters',
                req(v) {
                    return (v || '').toString().length > 0 || `Field is required`;
                },
            },
        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            eventBus.$on('refreshcalendar', this.onEmit_RefreshCalendar);
            eventBus.$on('refreshrestrictions', this.onEmit_RefreshCalendarRestrictions);

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            eventBus.$off('refreshcalendar', this.onEmit_RefreshCalendar);
            eventBus.$off('refreshrestrictions', this.onEmit_RefreshCalendarRestrictions);

		}, // eo function destroyed()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_shared_SchedulersSynchronizedMode',
            ]),


            /******************************************************************* 'DateFields Formatter'
            * formattedDateRangeFlightSchedule{}
            *
            * Desc:
            * Note:
            *
            */
            formattedDateRangeFlightSchedule: {

                get() {

                    const me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/FilterMenue.vue >>> computed/formattedDateRangeFlightSchedule/get');
                    if (me.inputDateRange.length === 2) {
                        //switch dates, so the range is valid
                        if(dayjs(me.inputDateRange[0]).isAfter(dayjs(me.inputDateRange[1]))) {
                            //switch val[0] und val[1]
                            [me.inputDateRange[0], me.inputDateRange[1]] = [me.inputDateRange[1], me.inputDateRange[0]];
                        }
                    }


                    return me.inputDateRange ? [...new Set(me.inputDateRange.map((date) => me.formatDateForTextField(date)))].sort((a,b) => {return new Date(b.date) - new Date(a.date)}) : [];

                }, // eo function formattedDateRangeFlightSchedule get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/FilterMenue.vue >>> computed/formattedDateRangeFlightSchedule/set');
                    return me.inputDateRange = value;

                }, // eo function formattedDateRangeFlightSchedule set()

            }, // eo formattedDateRangeFlightSchedule{}

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_load_ListEmployeesSchedulerDetails', // 'calendar'
                'actn_load_ListRestrictions', // 'restrictions'
                'actn_call_getLegsInfo', // 'flights'
            ]),


            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * on_Validate_Form()
            *
            * Desc: Check if Form is valid.
            * Desc: Then From/To Checks. If so ... Call.
            * Note:
            *
            */
            on_Validate_Form: function() {

                let me = this,
                    from = null,
                    to = null,
                    fromCheck = null,
                    toCheck = null,
                    date_fromto = null,
                    proceedingStatus = null,
                    hotelStatus = null,
                    paramsCalendar = {},
                    paramsFlights = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/FilterMenue.vue >>> on_Validate_Form');
                if (me.inputDateRange.length === 1) {
                    me.inputDateRange.push(me.inputDateRange[0]);
                }

                from =  dayjs(me.inputDateRange[0]).format('YYYY-MM-DDT00:00:00[Z]');
                to = dayjs(me.inputDateRange[1]).format('YYYY-MM-DDT23:59:59[Z]');


                // console.log('in on_Validate_Form()')
                // console.log('from: ' + from)
                // console.log('to: ' + to)




                // >>> --------------------------------------------------------- //
                date_fromto = me.inputDateRange[0].split('-');
                fromCheck = moment(date_fromto[0] + '-' + date_fromto[1] + '-' + date_fromto[2]); // for days diff
                date_fromto = me.inputDateRange[1].split('-');
                toCheck = moment(date_fromto[0] + '-' + date_fromto[1] + '-' + date_fromto[2]);  // for days diff

                if (toCheck.diff(fromCheck, 'days', false) > 31) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Please, 31 Days is the maximum.'
                    });
                    return;
                }



                // >>> --------------------------------------------------------- // go go go
                if (this.$refs.form && this.$refs.form.validate()) {

                    // >>> ----------------------
                    this.menu = false; // close
                    eventBus.$emit('tooltip', true); // reset Tooltip itself in scheduler
                    eventBus.$emit('resetTooltip'); // reset Tooltip Switch  in AppBar
                    eventBus.$emit('calibratezoomlevel', 2); // reset Zoomlevel itself in scheduler
                    eventBus.$emit('resetZoomlevel'); // reset Zoomlevel in AppBar
                    // eventBus.$emit('resetPartnering'); // reset Partnering Mode


                    // >>> ----------------------
                    if (this.duty) {
                        if (this.duty.includes('HOTEL')) {
                            hotelStatus = this.status;

                        }
                        if (this.duty.includes('PROCEEDING')) {
                            proceedingStatus = this.status;
                        }
                    }


                    // >>> calendar ------------- a)
                    paramsCalendar = {
                        'additionalFunction': this.funzione !== null ? this.funzione : null, // done: ['TRE-LR'],
                        'baseCodes': this.base !== null ? this.base : null, // done: ['TXL'],
                        'crewCodes': this.crewcodes !== null && this.crewcodes !== '' ? this.crewcodes.replace(/\s/g, '').split(",").map(String): null, // done: ['AAN', 'UDV'],
                        'dutyTypes': this.duty !== null ? this.duty : null, // done: ["HOTEL", "PROCEEDING"]
                        'position': this.position !== null ? this.position : null, // done: ['CP'],
                        'flightNos': this.flightnos !== null ? this.flightnos.replace(/\s/g, '').split(",").map(Number) : null, // done: [1550,6441]
                        'proceedingStatus': proceedingStatus, // done: 'BOOKED', 'PENDING' (for HTL, PRO only)
                        'hotelStatus': hotelStatus, // done: 'BOOKED', 'PENDING' (for HTL, PRO only)
                        'from': from, // open:
                        'to': to // open: + 31
                    };
                    this.actn_load_ListEmployeesSchedulerDetails(paramsCalendar);


                    // >>> restrictions ---------- b)
                    this.actn_load_ListRestrictions(paramsCalendar);


                    // >>> flights -------------- c)
                    if (this.get_shared_SchedulersSynchronizedMode === true) { // Guard:
                        paramsFlights = {
                            DOW: [],
                            flightNoDigits: this.flightnos !== null ? this.flightnos.replace(/\s/g, '').split(",").map(Number) : null, // TODO: does not work! #460
                            fromAptCode: null,
                            idAircraftConfig: null,
                            idFlight: null,
                            toAptCode: null,
                            from: from, // open:
                            to:  to, // open: + 31
                        };
                        this.actn_call_getLegsInfo( {payload: paramsFlights });
                    }

                }

            }, // eo function on_Validate_Form()


            /*******************************************************************
            * on_Validate_Form_Restrictions()
            *
            * Desc: Check if Form is valid.
            * Desc: Then From/To Checks. If so ... Call.
            * Note: Copy of on_Validate_Form() for Restrictions
            *
            */
            on_Validate_Form_Restrictions: function() {

                let me = this,
                    from = null,
                    to = null,
                    fromCheck = null,
                    toCheck = null,
                    date_fromto = null,
                    proceedingStatus = null,
                    hotelStatus = null,
                    paramsCalendar = {},
                    paramsFlights = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/FilterMenue.vue >>> on_Validate_Form');
                if (me.inputDateRange.length === 1) {
                    me.inputDateRange.push(me.inputDateRange[0]);
                }

                from =  dayjs(me.inputDateRange[0]).format('YYYY-MM-DDT00:00:00[Z]');
                to = dayjs(me.inputDateRange[1]).format('YYYY-MM-DDT23:59:59[Z]');


                // >>> --------------------------------------------------------- //
                date_fromto = me.inputDateRange[0].split('-');
                fromCheck = moment(date_fromto[0] + '-' + date_fromto[1] + '-' + date_fromto[2]); // for days diff
                date_fromto = me.inputDateRange[1].split('-');
                toCheck = moment(date_fromto[0] + '-' + date_fromto[1] + '-' + date_fromto[2]);  // for days diff

                if (toCheck.diff(fromCheck, 'days', false) > 31) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Please, 31 Days is the maximum.'
                    });
                    return;
                }



                // >>> --------------------------------------------------------- // go go go
                if (this.$refs.form && this.$refs.form.validate()) {

                    // >>> ----------------------
                    this.menu = false; // close
                    // eventBus.$emit('tooltip', true); // reset Tooltip itself in scheduler
                    // eventBus.$emit('resetTooltip'); // reset Tooltip Switch  in AppBar
                    // eventBus.$emit('calibratezoomlevel', 2); // reset Zoomlevel itself in scheduler
                    // eventBus.$emit('resetZoomlevel'); // reset Zoomlevel in AppBar
                    // eventBus.$emit('resetPartnering'); // reset Partnering Mode


                    // >>> ----------------------
                    if (this.duty) {
                        if (this.duty.includes('HOTEL')) {
                            hotelStatus = this.status;

                        }
                        if (this.duty.includes('PROCEEDING')) {
                            proceedingStatus = this.status;
                        }
                    }


                    paramsCalendar = {
                        'additionalFunction': this.funzione !== null ? this.funzione : null, // done: ['TRE-LR'],
                        'baseCodes': this.base !== null ? this.base : null, // done: ['TXL'],
                        'crewCodes': this.crewcodes !== null && this.crewcodes !== '' ? this.crewcodes.replace(/\s/g, '').split(",").map(String): null, // done: ['AAN', 'UDV'],
                        'dutyTypes': this.duty !== null ? this.duty : null, // done: ["HOTEL", "PROCEEDING"]
                        'position': this.position !== null ? this.position : null, // done: ['CP'],
                        'flightNos': this.flightnos !== null ? this.flightnos.replace(/\s/g, '').split(",").map(Number) : null, // done: [1550,6441]
                        'proceedingStatus': proceedingStatus, // done: 'BOOKED', 'PENDING' (for HTL, PRO only)
                        'hotelStatus': hotelStatus, // done: 'BOOKED', 'PENDING' (for HTL, PRO only)
                        'from': from, // open:
                        'to': to // open: + 31
                    };

                    this.actn_load_ListRestrictions(paramsCalendar);

                }

            }, // eo function on_Validate_Form_Restrictions()




            /*******************************************************************
            * onClick_datemenuFlightSchedule_OK()
            *
            * Desc:
            * Note:
            *
            */
            onClick_datemenuFlightSchedule_OK: function(date) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/FilterMenue.vue >>> onClick_datemenuFlightSchedule_OK');
                this.$refs.dates_dateMenuFlight.save(date);

            }, // eo function onClick_datemenuFlightSchedule_OK()


            /*******************************************************************
            * formatDateForTextField()
            *
            * Desc: Modify the date with the utc filter.
            * Note:
            *
            * @param {Object} date (date to format)
            */
            formatDateForTextField: function(date) {

                const me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/FilterMenue.vue >>> formatDateForTextField');
                return me.$options.filters.dayjsUtcDe(date, { showDayName: true });

            }, // eo function formatDateForTextField()




            /*******************************************************************
            * onEmit_RefreshCalendar()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_RefreshCalendar: function () {

                const me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/FilterMenue.vue >>> onEmit_RefreshCalendar');
                this.on_Validate_Form();

            }, // eo function onEmit_RefreshCalendar()


            /*******************************************************************
            * onEmit_RefreshCalendarRestrictions()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_RefreshCalendarRestrictions: function () {

                const me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/FilterMenue.vue >>> onEmit_RefreshCalendarRestrictions');
                this.on_Validate_Form_Restrictions();

            }, // eo function onEmit_RefreshCalendarRestrictions()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-text-field {
        padding-top: 5px !important;
    }
</style>

<style>
    /* */
    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }


    /* */
    .theme--light.v-input--is-disabled, .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
        font-size: 14px;
        font-weight: 400;
        color: #495057;
    }


    /* */
    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
        text-transform: uppercase;
    }


    /* */
    .v-toolbar__content .v-btn--flat .v-icon {
        font-size: 25px;
        color: #555 !important;
        margin-top: -3px;
        top: 0;
        position: relative;
        margin-right: 0px;
    }


    /* Filter Menue Button*/
    .v-sheet .v-toolbar__content .v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab), .v-sheet .v-toolbar__content .v-btn.v-size--large:not(.v-btn--icon):not(.v-btn--fab) {
        margin-bottom: 0
    }

    .v-toolbar__content .v-btn--flat .v-icon {
        font-size: 20px;
    }


    /* Combobox need to be "readonly", but chips need to displayed "normal" */
    .sdr-custom-dates-combobox .v-chip--disabled {
        opacity: 1;
        color: rgba(0, 0, 0, 0.87) !important;
    }
</style>
